module.exports = __webpack_public_path__ + "media/images/career_camp/2023/count_1-eda08f889df17cc36a8dd38a3ea98e3e.svg";